var generateStyle = function generateStyle(componentTheme) {
  return {
    answerOptionWrapper: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      borderRadius: componentTheme.answerOptionWrapperBorderRadius,
      border: "".concat(componentTheme.answerOptionWrapperBorder, " solid ").concat(componentTheme.answerOptionWrapperColor),
      '& div': {
        border: 'none'
      }
    }
  };
};
export default generateStyle;